// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/admin/notification-history`
  | `/admin/users`
  | `/admin/users/:id/edit`
  | `/bid-analyses`
  | `/bid-analyses/:id`
  | `/bid-analyses/:id/edit`
  | `/bid-analyses/new`
  | `/board-meetings`
  | `/calendar`
  | `/calendar/priority`
  | `/calendar/tracked`
  | `/callback`
  | `/changelog`
  | `/classifications`
  | `/classifications/:id`
  | `/classifications/:id/drugs`
  | `/classifications/:id/meetings`
  | `/classifications/new`
  | `/clients`
  | `/clients/:id`
  | `/clients/:id/edit`
  | `/clients/:id/users`
  | `/clients/:id/users/:userId/edit`
  | `/clients/:id/users/new`
  | `/clients/new`
  | `/daily-dose`
  | `/daily-dose/:id`
  | `/drug-coverage`
  | `/drug-coverage/drafts`
  | `/drug-coverage/drafts/:id`
  | `/drug-coverage/drafts/:id/review`
  | `/drug-coverage/drafts/new`
  | `/drug-utilizations`
  | `/drugs`
  | `/drugs/:id`
  | `/drugs/:id/coverage-tags`
  | `/drugs/:id/coverage-tags/:tagId/edit`
  | `/drugs/:id/coverage-tags/new`
  | `/drugs/:id/edit`
  | `/drugs/:id/market-share-report`
  | `/drugs/:id/meetings`
  | `/drugs/:id/packagings`
  | `/drugs/:id/packagings/:ndc`
  | `/drugs/:id/therapeutic-class-report`
  | `/drugs/new`
  | `/login`
  | `/market-baskets`
  | `/market-baskets/:id`
  | `/market-baskets/:id/edit`
  | `/market-baskets/new`
  | `/market-reports/market-share-report`
  | `/market-reports/therapeutic-class-report`
  | `/medicaid-datasets`
  | `/medicaid-datasets/new`
  | `/nadac`
  | `/notifications`
  | `/posts`
  | `/posts/:id/edit`
  | `/posts/new`
  | `/state-reports`
  | `/state-reports/manage-reports`
  | `/state-reports/manage-reports/:id`
  | `/state-reports/manage-reports/new`
  | `/terms-of-use`
  | `/user-settings`
  | `/user-settings/notifications`

export type Params = {
  '/admin/users/:id/edit': { id: string }
  '/bid-analyses/:id': { id: string }
  '/bid-analyses/:id/edit': { id: string }
  '/classifications/:id': { id: string }
  '/classifications/:id/drugs': { id: string }
  '/classifications/:id/meetings': { id: string }
  '/clients/:id': { id: string }
  '/clients/:id/edit': { id: string }
  '/clients/:id/users': { id: string }
  '/clients/:id/users/:userId/edit': { id: string; userId: string }
  '/clients/:id/users/new': { id: string }
  '/daily-dose/:id': { id: string }
  '/drug-coverage/drafts/:id': { id: string }
  '/drug-coverage/drafts/:id/review': { id: string }
  '/drugs/:id': { id: string }
  '/drugs/:id/coverage-tags': { id: string }
  '/drugs/:id/coverage-tags/:tagId/edit': { id: string; tagId: string }
  '/drugs/:id/coverage-tags/new': { id: string }
  '/drugs/:id/edit': { id: string }
  '/drugs/:id/market-share-report': { id: string }
  '/drugs/:id/meetings': { id: string }
  '/drugs/:id/packagings': { id: string }
  '/drugs/:id/packagings/:ndc': { id: string; ndc: string }
  '/drugs/:id/therapeutic-class-report': { id: string }
  '/market-baskets/:id': { id: string }
  '/market-baskets/:id/edit': { id: string }
  '/posts/:id/edit': { id: string }
  '/state-reports/manage-reports/:id': { id: string }
}

export type ModalPath = never

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
